import { useMemo } from 'react';

export default (t) => useMemo(() => ({
  custom: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  positionPeriodic: [
    {
      key: 'frequency',
      name: t('commandFrequency'),
      type: 'number',
    },
  ],
  setTimezone: [
    {
      key: 'timezone',
      name: t('commandTimezone'),
      type: 'string',
    },
  ],
  sendSms: [
    {
      key: 'phone',
      name: t('commandPhone'),
      type: 'string',
    },
    {
      key: 'message',
      name: t('commandMessage'),
      type: 'string',
    },
  ],
  message: [
    {
      key: 'message',
      name: t('commandMessage'),
      type: 'string',
    },
  ],
  sendUssd: [
    {
      key: 'phone',
      name: t('commandPhone'),
      type: 'string',
    },
  ],
  sosNumber: [
    {
      key: 'index',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'phone',
      name: t('commandPhone'),
      type: 'string',
    },
  ],
  silenceTime: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  setPhonebook: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  voiceMessage: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  outputControl: [
    {
      key: 'index',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  voiceMonitoring: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  setAgps: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  setIndicator: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  configuration: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  setConnection: [
    {
      key: 'server',
      name: t('commandServer'),
      type: 'string',
    },
    {
      key: 'port',
      name: t('commandPort'),
      type: 'number',
    },
  ],
  setOdometer: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  modePowerSaving: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  modeDeepSleep: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  alarmGeofence: [
    {
      key: 'radius',
      name: t('commandRadius'),
      type: 'number',
    },
  ],
  alarmBattery: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  alarmSos: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  alarmRemove: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  alarmClock: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  alarmSpeed: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  alarmFall: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'boolean',
    },
  ],
  alarmVibration: [
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  // JT1078 Video Commands
  requestVideo: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'mediaType',
      name: t('commandMediaType'),
      type: 'number',
    },
    {
      key: 'streamType',
      name: t('commandStreamType'),
      type: 'number',
    },
    {
      key: 'server',
      name: t('commandServer'),
      type: 'string',
    },
    {
      key: 'port',
      name: t('commandPort'),
      type: 'number',
    },
  ],
  stopVideo: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'streamType',
      name: t('commandStreamType'),
      type: 'number',
    },
  ],
  requestVideoPlayback: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'startTime',
      name: t('commandStartTime'),
      type: 'string',
    },
    {
      key: 'endTime',
      name: t('commandEndTime'),
      type: 'string',
    },
    {
      key: 'mediaType',
      name: t('commandMediaType'),
      type: 'number',
    },
    {
      key: 'streamType',
      name: t('commandStreamType'),
      type: 'number',
    },
    {
      key: 'memoryType',
      name: t('commandMemoryType'),
      type: 'number',
    },
    {
      key: 'playbackMethod',
      name: t('commandPlaybackMethod'),
      type: 'number',
    },
    {
      key: 'speedMultiplier',
      name: t('commandSpeedMultiplier'),
      type: 'number',
    },
    {
      key: 'server',
      name: t('commandServer'),
      type: 'string',
    },
    {
      key: 'port',
      name: t('commandPort'),
      type: 'number',
    },
  ],
  controlVideoPlayback: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'playbackControl',
      name: t('commandPlaybackControl'),
      type: 'number',
    },
    {
      key: 'speedMultiplier',
      name: t('commandSpeedMultiplier'),
      type: 'number',
    },
    {
      key: 'startTime',
      name: t('commandStartTime'),
      type: 'string',
    },
  ],
  // JT1078 Talk/Intercom Commands
  talkRequest: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'talkMode',
      name: t('commandTalkMode'),
      type: 'number',
    },
  ],
  talkControl: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'number',
    },
  ],
  uploadVideoControl: [
    {
      key: 'uploadSequence',
      name: t('commandUploadSequence'),
      type: 'number',
    },
    {
      key: 'uploadControlAction',
      name: t('commandUploadControlAction'),
      type: 'number',
    },
  ],
  // JT1078 Additional PTZ Commands
  ptzAperture: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'apertureType',
      name: t('commandApertureType'),
      type: 'number',
    },
  ],
  ptzZoomRatio: [
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'zoomRatio',
      name: t('commandZoomRatio'),
      type: 'number',
    },
  ],
  // JT808 Query/Upgrade Commands
  querySpecificParams: [
    {
      key: 'parameterIds',
      name: t('commandData'),
      type: 'string',
    },
  ],
  upgradePackage: [
    {
      key: 'upgradeType',
      name: t('commandUpgradeType'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  // JT808 Event/Text/Info Commands
  setEvent: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  sendQuestion: [
    {
      key: 'textType',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'textContent',
      name: t('commandMessage'),
      type: 'string',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  setInfoMenu: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  infoService: [
    {
      key: 'index',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'textContent',
      name: t('commandMessage'),
      type: 'string',
    },
  ],
  setPhoneBook: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  // JT808 Geofence Commands
  setRectangleGeofence: [
    {
      key: 'enable',
      name: t('commandEnable'),
      type: 'number',
    },
    {
      key: 'geofenceId',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'geofenceProps',
      name: t('commandData'),
      type: 'number',
    },
    {
      key: 'latitude',
      name: t('commandLatitude2'),
      type: 'string',
    },
    {
      key: 'longitude',
      name: t('commandLongitude2'),
      type: 'string',
    },
    {
      key: 'latitude2',
      name: t('commandLatitude2'),
      type: 'string',
    },
    {
      key: 'longitude2',
      name: t('commandLongitude2'),
      type: 'string',
    },
  ],
  deleteRectangleGeofence: [
    {
      key: 'geofenceId',
      name: t('commandIndex'),
      type: 'number',
    },
  ],
  setPolygonGeofence: [
    {
      key: 'geofenceId',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'geofenceProps',
      name: t('commandData'),
      type: 'number',
    },
    {
      key: 'vertices',
      name: t('commandData'),
      type: 'string',
    },
  ],
  deletePolygonGeofence: [
    {
      key: 'geofenceId',
      name: t('commandIndex'),
      type: 'number',
    },
  ],
  // JT808 Route Commands
  setRoute: [
    {
      key: 'routeId',
      name: t('commandRouteId'),
      type: 'number',
    },
    {
      key: 'geofenceProps',
      name: t('commandData'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  deleteRoute: [
    {
      key: 'routeId',
      name: t('commandRouteId'),
      type: 'number',
    },
  ],
  // JT808 Driving Record Commands
  collectDrivingRecord: [
    {
      key: 'recordCommand',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  setDrivingRecordParams: [
    {
      key: 'recordCommand',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
  // JT808 Additional Multimedia Commands
  queryMultimedia: [
    {
      key: 'mediaType',
      name: t('commandMediaType'),
      type: 'number',
    },
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'eventType',
      name: t('commandEventType'),
      type: 'number',
    },
    {
      key: 'startTime',
      name: t('commandStartTime'),
      type: 'string',
    },
    {
      key: 'endTime',
      name: t('commandEndTime'),
      type: 'string',
    },
  ],
  uploadMultimedia: [
    {
      key: 'mediaType',
      name: t('commandMediaType'),
      type: 'number',
    },
    {
      key: 'channel',
      name: t('commandChannel'),
      type: 'number',
    },
    {
      key: 'eventType',
      name: t('commandEventType'),
      type: 'number',
    },
    {
      key: 'startTime',
      name: t('commandStartTime'),
      type: 'string',
    },
    {
      key: 'endTime',
      name: t('commandEndTime'),
      type: 'string',
    },
    {
      key: 'mediaDelete',
      name: t('commandEnable'),
      type: 'number',
    },
  ],
  singleMultimediaQuery: [
    {
      key: 'mediaId',
      name: t('commandIndex'),
      type: 'number',
    },
    {
      key: 'mediaDelete',
      name: t('commandEnable'),
      type: 'number',
    },
  ],
  // JT808 Transparent Data
  transparentData: [
    {
      key: 'transparentType',
      name: t('commandTransparentType'),
      type: 'number',
    },
    {
      key: 'data',
      name: t('commandData'),
      type: 'string',
    },
  ],
}), [t]);
